import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from "@/router";
import { VueAxios } from './axios'
import { Modal, notification } from 'ant-design-vue'
import { DoneModals } from "@/utils/singleModal";


// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api base_url
  timeout: 999000, // 请求超时时间
  withCredentials: true
})
const err = (error) => {
  if (error.response) {
    let that = this;
    let data = error.response.data
    console.warn(error.response, "error.response.code")
    switch (error.response.code) {
      case 403:
        notification.error({ message: '系统异常', description: '拒绝访问', duration: 4 })
        break
      case 401:
        // notification.error({ message: '系统异常', description: 'Token失效，请重新登录!', duration: 4 })
        DoneModals.error({
          title: '登录已过期',
          content: '很抱歉，登录已过期，请重新登录',
          okText: '重新登录',
          mask: false,
          onOk: () => {
            store.dispatch('Logout').then(() => {
              router.push('/');
              localStorage.clear();
              try {
                let path = window.document.location.pathname
                if (path != "/" && path.indexOf('/login') == -1) {
                  window.location.reload()
                }
              } catch (e) {
                window.location.reload()
              }
            })
          }
        })
        break
      case 404:
        notification.error({ message: '系统异常', description: '很抱歉，资源未找到!', duration: 4 })
        break
      case 504:
        notification.error({ message: '系统异常', description: '网络超时' })
        break
      case 500:
        notification.error({ message: '系统异常', description: 'Unauthorized, please login again', duration: 4 })
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
        break
      default:
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  // config.headers = {
  //   "X-Frame-Options": "SAMEORIGIN"
  // }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  const res = response.data;
  const href = window.location.href;
  if (res.code && ![200, 501].includes(res.code)) {
    switch (res.code) {
      case 401:
        if (!href.includes('/login')) {
          DoneModals.error({
            title: '登录过期',
            content: '抱歉，请重新登录！',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                router.push('/');
                localStorage.clear();
                window.location.reload()
                try {
                  let path = window.document.location.pathname
                  if (path != "/" && path.indexOf('/login') == -1) {
                    window.location.reload()
                  }
                } catch (e) {
                  window.location.reload()
                }
              })
            }
          })
        }
        break;
      case 404:
        notification.error({ message: '系统异常', description: 'Sorry, resource not found!', duration: 4 })
        break;
      case 500:
        notification.error({ message: '系统提示', description: res.msg || 'Service exception!' })
        break;
      case 504:
        notification.error({ message: '系统异常', description: 'Network Timeout' })
        break
      default:
        notification.error({ message: '系统异常', description: res.msg })
        break;
    }

  } else {
    return response.data
  }

}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
// export {
//   installer,
//   service
// }